export default __webpack_public_path__ + "static/media/error.227dfc9d.png";